export default __webpack_public_path__ + "static/media/nomba.e2ea1ed9.jpeg";